// @ts-nocheck
import React, { useMemo } from 'react';
import intl from 'react-intl-universal';
import {
  Button,
  ButtonGroup,
  Intent,
  Menu,
  MenuDivider,
  MenuItem,
} from '@blueprintjs/core';
import { Icon } from '@/components';
import { safeCallback } from '@/utils';

export function ActionMenuList({
  row: { original },
  payload: { onEditShipMethod, onDeleteShipMethod },
}) {
  return (
    <Menu>
      <MenuItem
        icon={<Icon icon="pen-18" />}
        text={intl.get('edit_ship_method')}
        onClick={safeCallback(onEditShipMethod, original)}
      />
      <MenuDivider />
      <MenuItem
        icon={<Icon icon="trash-16" iconSize={16} />}
        text={intl.get('delete_ship_method')}
        onClick={safeCallback(onDeleteShipMethod, original)}
        intent={Intent.DANGER}
      />
    </Menu>
  );
}

function ActionsCell({
  row: { original },
  payload: { onEditShipMethod, onDeleteShipMethod },
}) {
  return (
    <ButtonGroup minimal={true}>
      <Button
            icon={<Icon icon="pen-18" iconSize={13} />}
            minimal
            onClick={safeCallback(onEditShipMethod, original)}
            style={{ marginRight: '5px', background : 'none' }}
          />
      <Button
        icon={<Icon icon="trash" iconSize={13} />}
        minimal
        onClick={safeCallback(onDeleteShipMethod, original)}
        style={{ background: 'none' }}
      />
    </ButtonGroup>
  );
}

export function useShipMethodsTableColumns() {
  return useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        width: 160,
      },
      {
        Header: 'Description',
        accessor: 'description',
        className: 'description',
        width: 240,
        textOverview: true,
      },
      {
        Header: 'Carrier',
        accessor: 'carrier.name',
        width: 140,
      },
      {
        Header: 'Status',
        accessor: 'is_active',
        width: 100,
        Cell: ({ cell: { value } }) => (
          <span
            style={{
              padding: '2px 10px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: 500,
              backgroundColor: value ? '#f6ffed' : '#fff2f0',
              color: value ? '#52C41A' : '#FF0000',
            }}
          >
            {value ? 'Active' : 'InActive'}
          </span>
        ),
      },
      {
        id: 'actions',
        Header: 'Actions',
        Cell: ActionsCell,
        className: 'actions',
        width: 100,
        disableResizing: true,
      },
    ],
    [],
  );
}
